import ListBeneficiaries from './ListBeneficiaries';
export default ListBeneficiaries;
